<template>
    <h3>个股香草</h3>
    <!-- 搜索表单 -->
    <SearchForm @submit="fetchData" :isSubmitting="isSubmitting" />
    <!-- 筛选条件区域 -->
    <el-collapse v-model="activeCollapse">
      <!-- 类型选择 -->
      <el-collapse-item title="结构类型" name="structure">
        <el-radio-group
          v-model="selectedStructure"
          @change="applyFilter"
          class="button-group"
          size="small"
        >
          <el-radio-button
            v-for="option in options"
            :key="option.value"
            :label="option.value"
            class="mobile-radio"
          >
            {{ option.label }}
          </el-radio-button>
        </el-radio-group>
      </el-collapse-item>

      <!-- 金额选择 -->
      <el-collapse-item title="投资金额" name="amount" style="display: none;">
        <el-radio-group
          v-model="selectedStructure_amount"
          @change="applyPrice"
          class="button-group"
          size="small"
        >
          <el-radio-button
            v-for="option in total_principal_options"
            :key="option.value"
            :label="option.value"
            class="mobile-radio"
          >
            {{ option.label }}
          </el-radio-button>
        </el-radio-group>
      </el-collapse-item>

      <!-- 券商选择 -->
      <el-collapse-item title="券商机构" name="brokerage" style="display: none;">
        <el-select
          v-model="selectedBrokerage"
          @change="applyBrokerageFilter"
          size="small"
          class="mobile-select"
          placeholder="请选择券商"
        >
          <el-option
            v-for="item in brokerage_options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-collapse-item>

      <!-- 时间选择 -->
      <el-collapse-item title="期权期限" name="times">
        <el-radio-group
          v-model="selectedTimes"
          @change="applyBrokerageFilter"
          class="button-group"
          size="small"
        >
          <el-radio-button
            v-for="option in times_options"
            :key="option.value"
            :label="option.value"
            class="mobile-radio"
          >
            {{ option.label }}
          </el-radio-button>
        </el-radio-group>
      </el-collapse-item>
    </el-collapse>

    <!-- 表格区域 -->
    <div v-if="tableData.length > 0" class="table-container">
      <StockTable :tableData="filteredTableData" :now_str="now_str" />
    </div>
</template>

<script>
import axios from 'axios';
import SearchForm from '@/components/SearchForm.vue';
import StockTable from '@/components/StockTable.vue';

export default {
  name: 'StockSearchFormPage',
  components: {
    SearchForm,
    StockTable
  },
  data() {
    return {
      isSubmitting: false,
      searchQuery: '',
      warring: '',
      tableData: [],
      originalTableData: [], // 添加原始数据副本
      selectedStructure: '100%',
      selectedStructure_amount: '1',
      selectedBrokerage: 'all', // 初始化为默认值
      selectedTimes: '1M',
      activeCollapse: ['structure','times'], // 默认展开的筛选条件
      options: [
        { value: '80%', label: '80%' },
        { value: '90%', label: '90%' },
        { value: '95%', label: '95%' },
        { value: '100%', label: '100%' },
        { value: '103%', label: '103%' },
        { value: '105%', label: '105%' },
        { value: '110%', label: '110%' }
      ],
      total_principal_options: [
        { value: '1', label: '100w' },
        { value: '2', label: '200w' },
        { value: '3', label: '300w' },
        { value: '4', label: '400w' },
        { value: '5', label: '500w' }
      ],
      brokerage_options: [
        { value: 'all', label: '全部' },
        { value: '银河', label: '银河' },
        { value: '华泰', label: '华泰' },
        { value: '中金', label: '中金' },
        { value: '中信', label: '中信' },
        { value: '永安', label: '永安' },
        { value: '浙期', label: '浙期' },
        { value: '国君', label: '国君' },
        { value: '广发', label: '广发' }
      ],
      times_options: [
        { value: '2w', label: '2w' },
        { value: '1M', label: '1M' },
        { value: '2M', label: '2M' },
        { value: '3M', label: '3M' },
        { value: '6M', label: '6M' }
      ],
      total_principal: '1', // 初始化为默认值
      total_principal_label: '100w', // 用于存储 label 值
      containerDisplay: false
    };
  },
  computed: {
    filteredTableData() {
      let filteredData = this.tableData;
      if (this.selectedStructure) {
        const startIndex = filteredData.findIndex(item => item.structure === this.selectedStructure);
        if (startIndex !== -1) {
          filteredData = filteredData.slice(startIndex, startIndex + 7);
        } else {
          filteredData = [];
        }
      }

      if (this.selectedBrokerage !== 'all') {
        filteredData = filteredData.filter(item => item[this.selectedBrokerage] !== 0);
      }

      return filteredData;
    }
  },
  methods: {
    applyPrice() {
      // 根据 selectedStructure_amount 计算倍数
      const selectedOption = this.total_principal_options.find(option => option.value === this.selectedStructure_amount);

      this.total_principal = selectedOption.value;
      this.total_principal_label = selectedOption.label;
      console.log('tableData:', this.tableData);
      this.tableData = this.originalTableData.map(item => {
        return {
          ...item,
          银河: item.银河 * this.total_principal,
          中信: item.中信 * this.total_principal,
          中金: item.中金 * this.total_principal,
          浙期: item.浙期 * this.total_principal,
          国君: item.国君 * this.total_principal,
          永安: item.永安 * this.total_principal,
          广发: item.广发 * this.total_principal
        };
      });
      this.tableData[0].total_principal_label = this.total_principal_label;
    },
    async fetchData(searchData) {
      // 从 SearchForm 接收包含 query 和 date 的对象
      const { query, date } = searchData;

      if (this.isSubmitting) return;
      console.log('开始请求数据:', query);
      this.isSubmitting = true;

      try {
        // 构建请求参数，只添加存在的参数
        const params = {
          code: query
        };

        // 如果有日期则添加日期参数
        if (date) {
          params.now_date = date;
        }

        const response = await axios.get(`/api/query`, {
          params,
          headers: {
            'Authorization': `Bearer ${this.$store.getters.token}`
          }
        });

        const responseData = response.data;
        if (responseData.stock_data_list != null) {
          this.data = responseData;
          this.generateTableData();
          this.containerDisplay = false;
        } else {
          this.data = {};
          this.$message.error(responseData.error || '不是两融标的');
        }
      } catch (error) {
        if (error.response && error.response.data && error.response.data.detail) {
          if (error.response.data.detail.includes('无法验证凭证')) {
            this.$store.dispatch('logout');
            this.$router.push('/login');
          }
          this.$message.error(error.response.data.detail);
        } else {
          // 使用更安全的错误消息访问方式
          this.$message.error(this.data?.error || '请求失败');
        }
      } finally {
        this.isSubmitting = false;
        console.log('请求完成');
      }
    },
    generateTableData() {
      const { stock_data_list } = this.data;
      this.now_str = this.data.now_str;
      this.tableData = [
        { angry_name: '银河T1',structure: '80%', ...this.extractValues(stock_data_list, '银河',[22, 23, 24, 25, 26]) },
        { angry_name: '中证资本T5', structure: '', ...this.extractValues(stock_data_list, '中信', [99, 6, 7, 8, 9]) },
        { angry_name: '国君T5',  structure: '',...this.extractValues(stock_data_list,'国君',  [99, 18, 19, 20, 21]) },
        { angry_name: '中金T8', structure: '', ...this.extractValues(stock_data_list, '中金', [99, 99, 99, 99, 99]) },
        { angry_name: '广发T5', structure: '', ...this.extractValues(stock_data_list, [99, 2, 3, 4, 5]) },
        { angry_name: '浙期T1',  structure: '',...this.extractValues(stock_data_list, '浙期', [99, 99, 99, 99]) },
        { angry_name: '永安T1', structure: '', ...this.extractValues(stock_data_list,'永安', [99, 99, 99, 99]) },


        { angry_name: '银河T1',structure: '90%', ...this.extractValues(stock_data_list,'银河', [27, 28, 29, 30, 31]) },
        { angry_name: '中证资本T5', structure: '', ...this.extractValues(stock_data_list, '中信', [99, 10, 11, 12, 13]) },
        { angry_name: '国君T5', structure: '', ...this.extractValues(stock_data_list,'国君',  [99, 22, 23, 24, 25]) },
        { angry_name: '中金T8', structure: '', ...this.extractValues(stock_data_list, '中金', [99, 99, 99, 99,99]) },
        { angry_name: '广发T5', structure: '', ...this.extractValues(stock_data_list, [99, 6, 7, 8, 9]) },
        { angry_name: '浙期T1',  structure: '',...this.extractValues(stock_data_list, '浙期', [99, 2, 8, 14, 20]) },
        { angry_name: '永安T1', structure: '', ...this.extractValues(stock_data_list,'永安', [99, 99, 99, 99, 99]) },



        { angry_name: '银河T1',structure: '95%', ...this.extractValues(stock_data_list,'银河', [32, 33, 34, 35, 36]) },
        { angry_name: '中证资本T5', structure: '', ...this.extractValues(stock_data_list, '中信', [99, 99, 99, 99, 99]) },
        { angry_name: '国君T5', structure: '', ...this.extractValues(stock_data_list,'国君',  [99, 99, 99, 99, 99]) },
        { angry_name: '中金T8', structure: '', ...this.extractValues(stock_data_list, '中金', [99, 99, 99, 99,99]) },
        { angry_name: '广发T5', structure: '', ...this.extractValues(stock_data_list, [99, 99, 99, 99, 99]) },
        { angry_name: '浙期T1', structure: '', ...this.extractValues(stock_data_list, '浙期', [99, 3, 9, 15, 21]) },
        { angry_name: '永安T1',  structure: '',...this.extractValues(stock_data_list,'永安', [99, 25, 26, 27, 28]) },


        { angry_name: '银河T1',structure: '100%', ...this.extractValues(stock_data_list, '银河', [2, 3, 4, 5, 6]) },
        { angry_name: '中证资本T5', structure: '', ...this.extractValues(stock_data_list, '中信', [99, 2, 3, 4, 5]) },
        { angry_name: '国君T5',  structure: '',...this.extractValues(stock_data_list, '国君', [99,  2, 3, 4, 5]) },
        { angry_name: '中金T8',  structure: '',...this.extractValues(stock_data_list,'中金', [99, 2, 3, 4,5]) },
        { angry_name: '广发T5', structure: '', ...this.extractValues(stock_data_list,'广发', [99, 10, 11, 12, 13]) },
        { angry_name: '浙期T1', structure: '', ...this.extractValues(stock_data_list,'浙期', [99,  4, 10, 16, 22]) },
        { angry_name: '永安T1',  structure: '',...this.extractValues(stock_data_list, '永安', [99, 3, 4, 5,6]) },


        { angry_name: '银河T1',structure: '103%', ...this.extractValues(stock_data_list,'银河', [7, 8, 9, 10, 11]) },
        { angry_name: '中证资本T5', structure: '', ...this.extractValues(stock_data_list, '中信', [99, 26, 27, 28,29]) },
        { angry_name: '国君T5', structure: '', ...this.extractValues(stock_data_list,'国君',  [99, 6,7,8,9]) },
        { angry_name: '中金T8', structure: '', ...this.extractValues(stock_data_list,'中金', [99, 99, 99, 99, 99]) },
        { angry_name: '广发T5', structure: '', ...this.extractValues(stock_data_list,'广发', [99, 14, 15, 16, 17]) },
        { angry_name: '浙期T1', structure: '', ...this.extractValues(stock_data_list, '浙期', [99, 5, 11, 17, 23]) },
        { angry_name: '永安T1', structure: '', ...this.extractValues(stock_data_list,'永安', [99, 7,8,9,10]) },



        { angry_name: '银河T1',structure: '105%', ...this.extractValues(stock_data_list,'银河', [12, 13, 14, 15, 16]) },
        { angry_name: '中证资本T5', structure: '', ...this.extractValues(stock_data_list,'中信', [99, 30, 31, 32,33]) },
        { angry_name: '国君T5', structure: '', ...this.extractValues(stock_data_list,'国君', [99, 10,11,12,13]) },
        { angry_name: '中金T8', structure: '', ...this.extractValues(stock_data_list,'中金', [99, 7,8, 9, 10]) },
        { angry_name: '广发T5', structure: '', ...this.extractValues(stock_data_list,'广发', [99, 18, 19, 20, 21]) },
        { angry_name: '浙期T1', structure: '', ...this.extractValues(stock_data_list,  '浙期',[99, 6, 12, 18, 24]) },
        { angry_name: '永安T1',  structure: '',...this.extractValues(stock_data_list,'永安', [99, 11,12,13,14]) },




        { angry_name: '银河T1',structure: '110%', ...this.extractValues(stock_data_list,'银河', [17, 18, 19, 20, 21]) },
        { angry_name: '中证资本T5', structure: '', ...this.extractValues(stock_data_list,'中信', [99, 34, 35,36,37]) },
        { angry_name: '国君T5', structure: '', ...this.extractValues(stock_data_list,'国君',  [99,14,15,16,17]) },
        { angry_name: '中金T8', structure: '', ...this.extractValues(stock_data_list,'中金', [99, 99, 99, 99, 99]) },
        { angry_name: '广发T5',  structure: '',...this.extractValues(stock_data_list,'广发',  [99,99, 99, 22, 23]) },
        { angry_name: '浙期T1',  structure: '',...this.extractValues(stock_data_list,'浙期', [99, 6, 12, 18, 24]) },
        { angry_name: '永安T1',  structure: '',...this.extractValues(stock_data_list,'永安', [99, 11,12,13,14]) },


      ];
      this.originalTableData = [...this.tableData];

    },
    extractValues(stock_data_list,name, indices) {
      const terms = ['2W', '1M', '2M', '3M', '6M'];
        const values = {};
        terms.forEach((term, index) => {
          values[term] = stock_data_list[name]?.[indices[index]] || 0;
        });
        return values;
    },
    applyBrokerageFilter() {
      // 这个方法在 computed 中的 filteredTableData 已经处理了
    }
  }
};
</script>

<style scoped>
/* 你可以根据需要添加样式 */
</style>
